import { Component } from 'react'
import { img } from 'stylewhere/assets'

export class Icons extends Component {
  static Barcode = img.iconBarcode
  static Play = img.iconPlay
  static AnimatedBar = img.animatedBar
  static Encoding = img.iconEncoding
  static Retry = img.iconRetry
  static Nfc = img.nfcIcon
  static Antenna = img.antennaIcon
  static Fullscreen = img.iconFullscreen
  static Search = img.iconSearch
  static AntennaOn = img.antennaOnIcon
  static Settings = img.iconSettings
  static ArrowDown = img.arrowDownIcon
  static ArrowRight = img.arrowRightIcon
  static ArrowDownBold = img.arrowDownBoldIcon
  static ArrowUpBold = img.arrowUpBoldIcon
  static Inbound = img.iconInbound
  static TagInfo = img.iconTagInfo
  static CheckGreen = img.checkGreenIcon
  static LeftArrow = img.iconLeftArrow
  static Info = img.iconInfo
  static Close = img.closeIcon
  static Cross = img.cross
  static LeftArrow1 = img.iconLeftArrow
  static Loader = img.loaderBlack
  static Rfid = img.rfidIcon
  static Close1 = img.close
  static Outbound = img.iconOutbound
  static Confirmed = img.confirmedIcon
  static Loader1 = img.loader
  static Pause = img.iconPause
  static RfidStation = img.logoStylewhereRfidStation
  static Serial = img.serialIcon
  static TransferToZone = img.transferToZoneIcon
  static Transfers = img.iconTransfers
  static Help = img.helpOutline
  static CheckFilled = img.checkFilled
  static Delete = img.delete
  static DeleteBlack = img.deleteBlack
  static SimpleItemList = img.simpleItemList
  static SimpleParcelList = img.simpleParcelList
  static Dots = img.dots
  static Minus = img.minus
  static Question = img.question
  static Tag = img.tag
  static TagBlack = img.tagBlack
  static AssociationError = img.associationError
  static Package = img.package
  static Refresh = img.refresh
  static ControlPanel = img.controlPanel
  static ControlPanelDetail = img.controlPanelDetail
  static Print = img.print
  static Confirm = img.confirm
  static Clear = img.clear
  static AssociationErrorWhite = img.associationErrorWhite
  static RfidWhite = img.rfidIconWhite
  static EncodingWhite = img.iconEncodingWhite
  static Trash = img.trash
  static Edit = img.edit
  static Component = img.component
  static Bug = img.bug
}
